module.exports = __webpack_public_path__ + "static/tomi-ogedengbe-d00fa197226c076b52cc0d19ce1f0d9e.jpeg";